import Footer from "../Footer"
import online from "../../Assets/images/online.svg"

function Onlinebank() {
  return (
    <>
        <div className="container bank-type mt-4">

      <div className="d-flex justify-content-center mt-5 sub-img">
      <img src={online} style={{height:"300px"}} alt="Online Bank" />
      </div>

    <h4 className="mt-5">What Is Online Banking?</h4>
    <div className="mt-3">
    <p>Online banking lets you manage your finances anywhere you have a computer or laptop and an internet connection. What you can do online depends on how robust your bank's digital banking platform is. Generally, you can complete basic banking activities like viewing recent transactions and transferring money between accounts. </p>
    <p>While you can also do many of the same banking activities at a physical, brick and mortar bank branch, online banking is a convenient alternative for most transactions.</p>
    </div>
  <h4 className="mt-5">How Does Online Banking Work?</h4>
    <div className="mt-3">
    <p>Online banking lets you make financial transactions from a web browser instead of trudging to the nearest bank. Mobile banking is similar, but it’s digital banking designed for portable electronics with smaller screens, such as smartphones and tablets. </p>
    <p>You can access your bank’s online banking system by going to your bank’s website and logging in to your account. Mobile banking is accessible through your bank’s app or mobile friendly web browser. Brick and mortar banks, online only banks, credit unions, and neobanks all have online banking options. </p>
    </div>
    
    <div className="mt-5">
    <h4>Key Online Banking Features & Content</h4>
    <ul className="mt-3">
        <li><b>Account Management :</b>  View balances, download statements, and monitor transactions in real time.</li>
        <li><b>Funds Transfer & Payments :</b> Send money between accounts, pay bills, and use person to person transfer services.</li>
        <li><b>Digital Services : </b> Remote check deposits via mobile app, cardless ATM access, and instant loan applications.</li>
        <li><b>Financial Tools :</b>   AI driven insights, spending trackers, and budgeting tools.</li>
        <li><b>Security Features :</b> Two factor authentication, biometric logins (fingerprint/face ID), and customizable fraud alerts.</li>
    </ul>
    </div>
   
   <div className="mt-5">
    <h4>Benefits of Online Banking</h4>
    <ul>
        <li><b>Accessibility :</b> Banking is available 24/7 from anywhere with an internet connection, reducing the need for physical branches.</li>
        <li><b>Higher Yields & Lower Fees  :</b> Online only banks often provide higher interest rates on savings (e.g., up to 3.00% or higher APY) and lower maintenance fees compared to traditional banks.</li>
        <li><b>Convenience : </b>  Quick, paperless onboarding and immediate access to services. </li>
    
    </ul>
    </div>
 
     </div>
     <Footer/>
    </>
  )
}

export default Onlinebank
